var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{ 'no-padding': _vm.noPadding === true }},[_vm._m(0,false,false),_c('div',{staticClass:"buyer"},[_vm._t("default")],2),_c('div',{staticClass:"clearfix"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seller"},[_c('div',{staticClass:"brand"},[_c('img',{attrs:{"src":require("../assets/logo.png"),"height":"60"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-002db3a0","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/print/LetterHead.vue
// module id = 637
// module chunks = 0